import { Component } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.scss',
  standalone: false,
})
export class ErrorPageComponent {

  constructor(public readonly authService: AuthService) { }

}
